import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesArrayMax } from './ITypeValidatesArrayMax';

export class ArrayMaxValidator
  implements ValidatorInterface<ITypeValidatesArrayMax>
{
  name = 'ArrayMax';

  friendlyName = 'List Maximum Size';

  arrayOnly = true;

  array = true;

  description = 'Maximum number of entries for this field';

  types = null;

  properties = {
    value: {
      type: 'Number',
      default: 1,
      validators: [
        {
          name: 'Required',
          value: true,
        },
        {
          name: 'Min',
          value: 1,
        },
        {
          name: 'Max',
          value: Number.MAX_SAFE_INTEGER,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesArrayMax) {
    type.addArrayMaxValidator(this);
  }
}

const arrayMaxValidator = new ArrayMaxValidator(undefined);

ValidatorRegistry.register(ArrayMaxValidator, arrayMaxValidator.name);

export { arrayMaxValidator };
